import { render } from "./App.vue?vue&type=template&id=a11b7436"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a11b7436&lang=css"

import exportComponent from "/var/www/vhosts/derbyweb.dev/selesti-vue-challenge.derbyweb.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__